<template>
  <div class="user" >
  <!-- @mouseleave="isPerson = false" @mouseenter="isPerson = true" -->
    <div @click="$router.push({ path: $route.fullPath, query: { menu: 'personal' } })">
      <Avatar icon="ios-person" v-if="!avatarInfo.url" />
      <Avatar :src="avatarInfo.url" v-else />
    </div>
    <span class="name">{{ username }}</span>
    <!-- <transition name="el-zoom-in-top">
      <ul class="drop" v-if="isPerson">
        <li @click="handleLogout">
          <img src="~_img/common/back.png" alt="" />
          <span>退出登录</span>
        </li>
      </ul>
    </transition> -->
    <transition name="el-zoom-in-top">
        <ul class="drop" v-if="isPerson">
          <li @click="orgChange">
            <img src="~_img/common/switch-organ.png" alt="" />
            <span>切换组织</span>
          </li>
          <li @click="handleLogout">
            <img src="~_img/common/back1.png" alt="" />
            <span>退出登录</span>
          </li>
        </ul>
      </transition>
    <SwitchOrg v-model="orgPopup" @mouseleave.stop @mouseenter.stop/>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/common'
import SwitchOrg from './switchOrg.vue'
export default {
  components:{SwitchOrg},
  data() {
    return {
      username: '',
      isPerson: false,
      avatarInfo: {},
      orgPopup:false
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      let user = await getUserInfo()
      this.username = user.displayName
      // 获取用户头像
      this.$api.user.getAvatar({ userId: user.id }).then((info) => {
        this.avatarInfo = { url: info.data[0] && info.data[0].attributeContent }
      })
    },
    orgChange(){
      this.orgPopup=true
    },
    handleLogout() {
      sessionStorage.clear()
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.user {
  position: relative;
  height: 100%;
  font-size: 16px;
  .flex-center();
  cursor: pointer;
  .name {
    margin-left: 10px;
    color: #fff;
  }
  .drop {
    position: absolute;
    top: 50px;
    background: #fff;
    width: 160px;
    padding: 0 10px 20px;
    z-index: 101;
    .flex-column();
    align-items: center;
    box-shadow: 5px 5px 20px 0px rgba(168, 206, 230, 0.59), 3px 3px 12px 0px #e0e2fa;
    cursor: pointer;
    border-radius: 3px;
    color: #141e25;

    li {
      margin-top: 20px;
      display: flex;
      align-items: center;
      span {
        margin-right: 10px;
      }
      img {
        width: 16px;
        margin-right: 10px;
      }
    }
    li:nth-child(2) {
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 86%;
        height: 1px;
        background: #c9cfff;
      }
    }
  }
}
</style>
